/** @format */
import styled from 'styled-components';

import { StyledSectionPreviewBlock } from '../section-preview-block.styles';
import { StyledSectionPreviewBlockProps } from '../types';

// eslint-disable-next-line @mpb-com/mpb/no-exported-styled-component -- Legacy code: do not use as an example.
export const StyledSectionPreviewBlockSkeleton = styled(
    StyledSectionPreviewBlock
)<StyledSectionPreviewBlockProps>`
    .image-skeleton {
        width: 100%;
        height: 100%;
    }
`;
